<template>
  <div>
    <filter-bar class="filter-bar">
      <div class="md-layout-item md-size-20 md-medium-size-50 md-xsmall-size-100">
        <div class="outlined-field">
          <md-field>
            <label>Almacén</label>
            <md-select :disabled="loading" v-model="advanceFilters.warehouse">
              <md-option
                v-for="warehouse in fetchedWarehouses"
                :key="warehouse.id"
                :value="warehouse.id"
              >{{ warehouse.name }}</md-option>
            </md-select>
          </md-field>
        </div>
      </div>

      <div class="md-layout-item md-size-20 md-medium-size-50 md-xsmall-size-100">
        <div class="outlined-field">
          <md-field>
            <label>Estatus</label>
            <md-select :disabled="loading" v-model="advanceFilters.status">
              <md-option
                v-for="status in allowedStatus"
                :key="status.id"
                :value="status.id"
              >{{ status.name }}</md-option>
            </md-select>
            <md-button
              class="md-round md-just-icon md-simple md-danger"
              :disabled="loading"
              @click="advanceFilters.status = null"
            >
              <md-icon>close</md-icon>
            </md-button>
          </md-field>
        </div>
      </div>
      <div class="md-layout-item md-size-20 md-medium-size-50 md-xsmall-size-100">
        <div class="outlined-field">
          <md-field>
            <label for="type_of_job">Tipo</label>
            <md-select :disabled="loading" v-model="advanceFilters.jobType">
              <md-option v-for="type in jobTypes" :key="type.id" :value="type.name">{{ type.name }}</md-option>
            </md-select>
            <md-button
              class="md-round md-just-icon md-simple md-danger"
              :disabled="loading"
              @click="advanceFilters.jobType = ''"
            >
              <md-icon>close</md-icon>
            </md-button>
          </md-field>
        </div>
      </div>

      <div class="md-layout-item md-size-20 md-medium-size-50 md-xsmall-size-100">
        <md-field>
          <label for="dateOccurred">
            <md-icon>calendar_today</md-icon>
            {{ advanceFilters.fromDate ? "" : "Fecha de Solicitud" }}
          </label>
          <datetime
            :disabled="loading"
            input-style="border: none; outline:none; width: 100%"
            type="date"
            input-class="Object"
            title="Fecha de Solicitud"
            value-zone="America/Mexico_City"
            :phrases="{ ok: 'Ok', cancel: 'Cancelar' }"
            v-model="advanceFilters.fromDate"
          ></datetime>
          <md-button
            class="md-info md-simple md-just-icon"
            :disabled="loading"
            @click="advanceFilters.fromDate = ''"
          >
            <md-icon>close</md-icon>
          </md-button>
        </md-field>
      </div>
      <div class="md-layout-item md-size-15 md-medium-size-50 md-xsmall-size-100">
        <div class="outlined-field">
          <md-field>
            <label>OC</label>
            <md-input :disabled="loading" v-model="advanceFilters.purchaseOrder"></md-input>
          </md-field>
        </div>
      </div>
      <template slot="actions">
        <md-button class="md-info" @click="fetchAdvances(advanceFilters)">Buscar</md-button>
        <div>
          <md-button
            class="md-success"
            @click="downloadUserFile(advanceFilters)"
          >Descargar Plantilla de Pagos</md-button>
          <md-button
            class="md-success"
            @click="downloadBeneficiaries(advanceFilters)"
          >Descargar Beneficiarios</md-button>
        </div>
      </template>
    </filter-bar>

    <md-table
      v-if="!loading && fetchedAdvances.length"
      :md-sort.sync="currentSort"
      md-sort-order.sync="asc"
    >
      <md-table-toolbar class="md-layout md-alignment-center-space-between">
        <p class="md-headline">Anticipos</p>
      </md-table-toolbar>

      <md-table-row slot="md-table-row">
        <md-table-cell></md-table-cell>
        <md-table-cell>#</md-table-cell>
        <md-table-cell
          v-for="({ name }, index) in tableHeaders"
          class="table__cell-header"
          :key="index"
        >{{ name }}</md-table-cell>
        <md-table-cell></md-table-cell>
      </md-table-row>
      <template v-for="(data, index) in filteredAdvances">
        <md-table-row :key="data.id">
          <md-table-cell>
            <md-button
              v-if="data.sinisters.length"
              class="md-round md-just-icon md-info"
              @click="data.showSinisters = !data.showSinisters"
            >
              <md-icon>
                {{
                !data.showSinisters ? "expand_more" : "expand_less"
                }}
              </md-icon>
            </md-button>
          </md-table-cell>
          <md-table-cell>
            <strong>{{ index + 1 }}</strong>
          </md-table-cell>
          <md-table-cell v-for="{ value, filter } in tableHeaders" :key="value" class="table__cell">
            <span
              class="btn-link"
              v-if="value === 'folio'"
              @click="goToPurchaseOrder(data)"
            >{{ data[value] }}</span>
            <span v-else-if="filter === 'status'">{{ data[value] }}</span>
            <span v-else-if="filter === 'money'">{{ data[value] | money }}</span>
            <span v-else-if="filter === 'moneyLong'">{{ data[value] | moneyLong }}</span>
            <span v-else-if="filter === 'percentaje'">{{ data[value] | percentaje }}</span>
            <span v-else-if="value === 'providerCompleteInfo'">{{ data[value] }}</span>
            <div
              v-else-if="value === 'providerTypes'"
              style="display: flex; flex-direction: column; max-width: 120px;"
            >
              <span>
                {{
                data.seeMoreProviderTypes ?
                data[value].join(", ") :
                data[value][0]
                }}
              </span>
              <button
                v-if="data[value].length > 1"
                class="btn-link"
                @click="data.seeMoreProviderTypes = !data.seeMoreProviderTypes"
              >{{ !data.seeMoreProviderTypes ? "Ver más" : "Ver menos" }}</button>
            </div>
            <span v-else-if="value === 'dateRequest'">
              <p v-for="(advance, index) in data.advances" :key="index">{{ advance.date }}</p>
            </span>
            <span v-else>{{ data[value] }}</span>
          </md-table-cell>
          <md-table-cell>
            <md-button
              v-if="!!data.advances.length"
              class="md-round md-just-icon md-primary"
              @click="seeAdvances(data, index)"
            >
              <md-icon>visibility</md-icon>
            </md-button>
          </md-table-cell>
        </md-table-row>

        <md-table-row class="supplies__row" v-show="data.showSinisters">
          <md-table-cell :colspan="tableHeaders.length + 3" v-if="data.sinisters.length">
            <md-table class="md-elevation-2">
              <md-table-toolbar style="min-height: 48px">
                <h1 class="md-subheading">
                  <strong>{{ data.sinisters.length }} Siniestros relacionados</strong>
                </h1>
              </md-table-toolbar>
              <md-table-row>
                <md-table-head>Siniestro</md-table-head>
                <md-table-head>Requisición</md-table-head>
                <md-table-head>Folio</md-table-head>
                <md-table-head colspan="7"></md-table-head>
              </md-table-row>

              <md-table-row
                v-for="sinister in data.sinisters"
                :key="`${sinister.id}.${sinister.sinisterNumber}.${sinister.folio}`"
              >
                <md-table-cell>
                  <div>
                    <button class="btn-link" @click="goToSinisterFile(sinister)">
                      {{ sinister.sinisterNumber }}
                      <md-tooltip md-direction="top">Ir a ficha</md-tooltip>
                    </button>
                  </div>
                </md-table-cell>
                <md-table-cell>{{ sinister.folio }}</md-table-cell>
                <md-table-cell>{{ sinister.requisitionNumber }}</md-table-cell>
                <md-table-cell colspan="5"></md-table-cell>
              </md-table-row>
            </md-table>
          </md-table-cell>
        </md-table-row>
      </template>
    </md-table>

    <div v-else-if="!fetchedAdvances.length">
      <loading-content :loading="loading" slot="empty-state" empty-label="No hay resultados" />
    </div>

    <modal width="70%" v-if="advanceModal" @close="hideAdvanceModal">
      <template slot="header">
        <h4 class="info-text">Detalle de la orden de compra {{ currentOrder.folio }} (Anticipos)</h4>
      </template>
      <template slot="body">
        <table-advances
          v-model="fetchedAdvancesByOrder"
          :fetchedStatus="fetchedStatus"
          @changeStatusItem="changeStatusAdvances"
          @resetData="resetData"
        />
      </template>
    </modal>
  </div>
</template>

<script>
// COMPONENTS
import FilterBar from "@/components/FilterBar";
import { Modal } from "@/components";
import TableAdvances from "./TableAdvances";
import SeeMoreLess from "@/components/Inputs/SeeMoreLess";

// SERVICES
import advanceService from "@/services/purchase/advance";
import catalogService from "@/services/catalog";
import warehouseService from "@/services/purchase/warehouse";
import sinisterService from "@/services/sinister";

// UTILS
import moment from "moment";
import urlUtility from "@/utils/assetURL";
import { isImageURL, downloadFile } from "@/utils";
import { mapPermissions } from "@/plugins/accountPermissions/";

export default {
  name: "AdvanceReportIndex",
  components: { Modal, TableAdvances, FilterBar, SeeMoreLess },
  data() {
    return {
      currentSort: "sinisterNumber",
      loading: true,
      advanceModal: false,
      DummyData: null,
      advanceFilters: {
        fromDate: null,
        toDate: null,
        status: null,
        warehouse: null,
        provider: null,
        purchaseOrder: "",
      },
      providers: [],
      jobTypes: [],
      fetchedAdvances: [],
      fetchedAdvancesByOrder: [],
      fetchedStatus: [],
      fetchedWarehouses: [],
      currentItem: null,
      currentOrder: {},
      tableHeaders: [
        { name: "Folio", value: "folio" },
        { name: "Estatus", value: "status" },
        { name: "Usuario que lo solicitó", value: "user" },
        { name: "Almacen", value: "iwarehouse" },
        { name: "Fecha Solicitud", value: "dateRequest" },
        { name: "Fecha OC", value: "date" },
        { name: "Tipo de Proveedor", value: "providerTypes" },
        { name: "Proveedor", value: "providerCommercialName" },
        {
          name: "Total solicitud anticipos",
          value: "advanceRequest",
          filter: "money",
        },
        { name: "Banco", value: "providerBankName" },
        { name: "Clabe", value: "providerClabe" },
        { name: "Total", value: "total", filter: "money" },
        {
          name: "Subtotal anticipos",
          value: "totalAdvances",
          filter: "money",
        },
        { name: "Total restante", value: "totalRemaining", filter: "money" },
      ],
    };
  },
  computed: {
    ...mapPermissions("PurchaseRequisition", "advances", ["add", "change"]),
    allowedStatus() {
      const allowedStatus = ["capturado", "aprobado", "cancelado", "saldado"];
      return this.fetchedStatus.filter(({ slug }) => {
        return allowedStatus.includes(slug.toLowerCase());
      });
    },
    getProviders() {
      return this.providers.map((provider) => ({
        ...provider,
        toLowerCase: () =>
          provider.provider_number.toLowerCase() || provider.name.toLowerCase(),
        toString: () => provider.provider_number,
      }));
    },
    filteredAdvances() {
      const { jobType: jobTypeFilter } = this.advanceFilters;
      const { fetchedAdvances } = this;
      return !jobTypeFilter
        ? fetchedAdvances
        : fetchedAdvances.filter(
            ({ sinisters }) =>
              sinisters.length &&
              sinisters.some(({ jobType }) => jobType === jobTypeFilter)
          );
    },
  },
  methods: {
    providerSelected({ id }) {
      this.advanceFilters.provider = null;
      id
        ? (this.advanceFilters.provider = id)
        : (this.advanceFilters.provider = null);
    },
    fetchAdvances({ status, ...params }) {
      this.loading = true;
      advanceService
        .fetchAdvances({ status, ...params })
        .then((res) => {
          this.fetchedAdvances = [...res].filter((a) => a.isActive);
          this.setHeaders(status);
        })
        .catch(this.$fireErrorResponse)
        .finally(() => (this.loading = false));
    },
    setHeaders(statusId) {
      const status = this.fetchedStatus.find(({ id }) => id === statusId);
      if (status && status.slug === "capturado") {
        this.tableHeaders[8] = {
          name: "Total solicitud anticipos",
          value: "advanceRequest",
          filter: "money",
        };
      } else {
        this.tableHeaders[8] = {
          name: "Cuenta",
          value: "providerBankAccount",
        };
      }
    },
    hideAdvanceModal() {
      this.advanceModal = false;
    },
    seeAdvances({ advances, folio }, index) {
      this.currentItem = index;
      this.currentOrder = { folio };
      this.advanceModal = true;
      this.fetchedAdvancesByOrder = advances.map((a) => {
        return {
          ...a,
          changed: false,
          statusCodename: null,
          lastStatus: a.advanceType,
        };
      });
    },
    seeFile(file) {
      const cFile = urlUtility(file);
      if (!isImageURL(file)) {
        const win = window.open(cFile, "_blank");
        win.focus();
      }
    },
    changeStatusAdvances() {
      Promise.all(
        this.fetchedAdvancesByOrder
          .filter(({ changed }) => changed)
          .map((advance) => advanceService.changeAdvanceStatusReport(advance))
      )
        .then(() => {
          this.$successMessage({ title: "Cambios guardados" });
          this.fetchedAdvances[this.currentItem].advances =
            this.fetchedAdvancesByOrder.filter(({ changed }) => !changed);
          this.advanceModal = false;
        })
        .catch(this.$fireErrorResponse);
    },

    goToSinisterFile({ id }) {
      const routeData = this.$router.resolve({
        name: "Ficha de Siniestro Carretero",
        params: {
          id,
        },
      });
      window.open(routeData.href, "_blank");
    },
    goToPurchaseOrder({ folio, iwarehouse }) {
      const warehouse = this.fetchedWarehouses.find(
        ({ name }) => name === iwarehouse
      );
      const routeData = this.$router.resolve({
        name: "Seguimiento de compras",
        query: {
          almacen: warehouse.id,
          folio: folio.substring(3),
        },
      });
      window.open(routeData.href, "_blank");
    },
    resetData() {
      this.advanceModal = false;
      this.fetchedAdvancesByOrder = this.fetchedAdvancesByOrder.map((a) => {
        return {
          ...a,
          status: a.lastStatus,
          change: false,
          statusCodename: null,
        };
      });
    },
    reduceOptions({ lastStatus }) {
      const allowed = this.advanceStatus.filter(
        ({ permission }) => permission === undefined || permission
      );

      return lastStatus === "Activo"
        ? allowed
        : allowed.filter(({ codename }) => codename !== "active");
    },
    downloadBeneficiaries() {
      const params = {
        status: this.advanceFilters.status ? this.advanceFilters.status : "",
        job_type: this.advanceFilters.jobType,
        start: this.advanceFilters.fromDate
          ? moment(this.advanceFilters.fromDate).format("YYYY-MM-DD")
          : null,
        beneficiariesxls: true,
      };
      downloadFile(
        `/purchase/list/purcharse/orders/`,
        `beneficiarios_${params.start}_JBG.xlsx`,
        {
          config: { params },
        }
      )
        .then(() => {
          this.$notify({
            message: "Descargando archivo.",
            icon: "close",
            horizontalAlign: "center",
            verticalAlign: "top",
            type: "success",
          });
        })
        .catch(this.$fireErrorResponse);
    },
    downloadUserFile() {
      const params = {
        status: this.advanceFilters.status
          ? this.advanceFilters.status
          : undefined,
        job_type: this.advanceFilters.jobType,
        start: this.advanceFilters.fromDate
          ? moment(this.advanceFilters.fromDate).format("YYYY-MM-DD")
          : null,
        paymentsxls: true,
      };
      downloadFile(
        `/purchase/list/purcharse/orders/`,
        `plantilla_de_pagos_${params.start}_JBG.xlsx`,
        {
          config: {
            params,
          },
        }
      )
        .then(() => {
          this.$notify({
            message: "Descargando archivo.",
            icon: "close",
            horizontalAlign: "center",
            verticalAlign: "top",
            type: "success",
          });
        })
        .catch(this.$fireErrorResponse);
    },
    downloadReport() {
      const {
        from: fromP,
        to: toP,
        highway,
        job: sinisterType,
      } = this.filtersParams;
      const from = fromP ? moment(fromP).format("YYYY-MM-DD") : undefined;
      const to = toP ? moment(toP).format("YYYY-MM-DD") : undefined;
      const highways =
        highway && highway.length ? highway.join(",") : undefined;
      downloadFile("sinisters/sinister_download_report/", "reporte.xls", {
        config: {
          params: {
            type: "xls",
            fromDate: from,
            toDate: to,
            highway: highways,
            sinisterType: sinisterType ? sinisterType : undefined,
          },
        },
      })
        .then(() => {
          this.$notify({
            message: "Archivo descargado",
            icon: "close",
            horizontalAlign: "center",
            verticalAlign: "top",
            type: "success",
          });
        })
        .catch(this.$fireErrorResponse);
    },
  },
  mounted() {
    this.advanceFilters = {
      fromDate: moment().subtract(5, "days").format("YYYY-MM-DD"),
      toDate: null,
      warehouse: 0,
    };

    Promise.all([
      catalogService.fetch("common/status"),
      warehouseService.fetchiWarehouse(),
      catalogService.fetch("providers"),
      sinisterService.fetchJobTypes(),
    ])
      .then(([statuses, warehouses, providers, jobTypes]) => {
        this.providers = providers.sort((a, b) => (a.slug < b.slug ? -1 : 1));
        this.fetchedStatus = statuses.sort((a, b) =>
          a.name < b.name ? -1 : 1
        );
        const listWarehouses = warehouses.sort((a, b) =>
          a.name < b.name ? -1 : 1
        );
        this.fetchedWarehouses = [{ name: "Todos", id: 0 }, ...listWarehouses];
        const status = this.fetchedStatus.find(
          ({ slug }) => slug === "capturado"
        );
        this.advanceFilters.status = status.id;
        this.jobTypes = jobTypes;
        return advanceService.fetchAdvances(this.advanceFilters).then((res) => {
          this.fetchedAdvances = [...res].filter((a) => a.isActive);
        });
      })
      .catch(this.$fireErrorResponse)
      .finally(() => (this.loading = false));
  },
};
</script>

<style lang="scss" scoped>
.md-card {
  .md-card-content {
    padding: 0px 15px;
    line-height: 1.75em;
    position: relative;
  }
}
.supplies__row {
  background-color: #f9f9f9 !important;
  margin: auto;
  padding: 10px 25px;
}
.vdatetime {
  margin-left: 2em;
  margin-top: 1.1em;
  width: 100%;
}
.button-header {
  position: absolute;
  top: 0%;
  right: 0%;
  transform: translate(-10%, -90%);
  font-size: 10px;
  color: black !important;
}
.btn-link {
  font-weight: 600;
}
</style>



// WEBPACK FOOTER //
// src/pages/Purchases/Advances/index.vue